import swal from "sweetalert";

export const showResetPasswordSuccessModal = ({ intl, message, onAccept }) => {
  swal({
    title: intl.formatMessage({
      id: "CLIENT.RESET.RESET_PASSWORD_SUCCESS_TITLE",
    }),
    text: message,
    icon: "success",
    button: intl.formatMessage({
      id: "CLIENT.GENERAL.OK_BUTTON",
    }),
  }).then(() => {
    onAccept();
  });
};

export const showResetPasswordFailedModal = ({ intl, message, onAccept }) => {
  swal({
    title: intl.formatMessage({
      id: "CLIENT.RESET.RESET_PASSWORD_FAIL_TITLE",
    }),
    text: message,
    icon: "error",
    button: intl.formatMessage({
      id: "CLIENT.GENERAL.OK_BUTTON",
    }),
  }).then(() => {
    onAccept();
  });
};
